import DataCard from 'components/data-card/data-card.component';
import { useTranslation } from 'react-i18next';
import { formatCreatedDate } from '../customer-overview.utils';

type CustomerCreatedDateProps = {
  createdDate: string;
};

const CustomerCreatedDate = ({ createdDate }: CustomerCreatedDateProps) => {
  const { t } = useTranslation();

  return (
    <DataCard
      title={t('page.customers.overview.accountCreatedOn')}
      value={formatCreatedDate(createdDate)}
    />
  );
};

export default CustomerCreatedDate;
